var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-tag"},[_c('img',{staticClass:"tag-icon",attrs:{"src":require("../../assets/icons/svg/ic_date_active.svg"),"alt":""}}),_c('span',{staticClass:"tag-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }